<template>
  <div class="bakatpil">

      <div class="huvud">
      <div class="del1"></div>
      <div class="del2"></div>
    </div>
      <div class="del3"></div>
      <div class="del4"></div>


  </div>

</template>

<script>
export default {
  name: 'Bakatpil',
  props: {
    msg: String
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

.bakatpil {
    display: inline-block;
}

.huvud {
    display: inline-block;
}
.del1 {
    display: block;
    height: 10px;
    width: 10px;
    border-width: 1px;
    border-style: solid solid none none;
    border-color: black;
    transform: rotate(-45deg);
}
.del2 {
    position: relative;
    display: block;
    height: 10px;
    width: 10px;
    border-width: 1px;
    border-style: none none solid solid;
    border-color: black;
    left: 5px;
    bottom: 10px;
}
.del3 {
    display: inline-block;
    border-width: 1px;
    height: 10px;
    width: 50px;
    border-style: solid none none none;
}
.del4 {
    position: relative;
    display: inline-block;
    height: 10px;
    width: 10px;
    border-width: 1px;
    border-style: none solid solid none;
    border-color: black;
    left: 0px;
    bottom: 10px;
}



</style>
